<template>
	<v-container>
		<v-row class="contentRow">
			<v-col>
				<h1 class="mb-2">Connections List</h1>
				<p class="mb-10 text-center">
					This is a list of connections between you and other companies.
				</p>

				<v-text-field label="Search" v-model="search" prepend-inner-icon="fas fa-search">
				</v-text-field>

				<v-data-table :search="search" :loading="loading" theme-- light :headers="headers" :items="connections"
					:footer-props="{
						'items-per-page-options': [5, 10, 15],
					}" :items-per-page="20" class="light table">
					<template v-slot:item.clientID="{ item }">
						<span>
							{{ item.clientID }}
						</span>
						<span v-if="item.IsGuest == 1" style="color: #1e7c83;">
							(Guest User)
						</span>
					</template>
					<template v-slot:item.remove="{ item }">
						<v-btn color="red" v-on:click="showDeleteDialog(item)">
							<v-icon color="white" small>fas fa-times</v-icon>
						</v-btn>
					</template>
					<template v-slot:item.view="{ item }">
						<v-btn color="primary" v-on:click="redirectTo(item)">
							<v-icon color="white" small>fas fa-eye</v-icon>
						</v-btn>
					</template>
				</v-data-table>
			</v-col>
			<v-dialog v-model="dialogDelete" max-width="500px">
				<v-card>
					<v-card-title>Are you sure you want to remove this connection?</v-card-title>
					<v-card-text>Once it is removed, you must send a new request to create a
						connection</v-card-text>
					<v-card-actions>
						<v-btn color="primary" text @click="dialogDelete = false">Close</v-btn>
						<v-btn color="error" text @click="removeRow">Delete</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-row>
		<v-row>
			<v-col>
				<h1 class="text-center">Projects List</h1>
				<p class="text-center">
					This is a list of Projects that your company follows currently.
				</p>
			</v-col>
		</v-row>
		<v-row>
			<v-col class="text-right">
				<v-btn color="primary" @click="dialogCreateProject = true">
					Create New Project
				</v-btn>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-data-table :search="search" :loading="loading" theme-- light :headers="headersProject"
					:items="projects" :footer-props="{
						'items-per-page-options': [5, 10, 15],
					}" :items-per-page="20" class="light table">
										<template v-slot:item.delete="{ item }">
						<v-btn color="red" v-on:click="showDeleteProjectDialog(item)">
							<v-icon color="white" small>fas fa-times</v-icon>
						</v-btn>
					</template>
					<template v-slot:item.view="{ item }">
						<v-btn color="primary" v-on:click="showProjectDetails(item)">
							<v-icon color="white" small>fas fa-eye</v-icon>
						</v-btn>
					</template>
				</v-data-table>
			</v-col>
			<v-dialog v-model="dialogProjectDelete" max-width="500px">
				<v-card>
					<v-card-title>Are you sure you want to Delete this Project?</v-card-title>
					<v-card-text>Once it is Deleted, you will not able to recover</v-card-text>
					<v-card-actions>
						<v-btn color="primary" text @click="dialogProjectDelete = false">Close</v-btn>
						<v-btn color="error" text @click="DeleteProject">Delete</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-row>
		<!-- Create New Project Dialog -->
		<v-dialog v-model="dialogCreateProject" max-width="600px" persistent>
			<v-card>
				<v-card-title>Create New Project</v-card-title>
				<v-card-text>
					<v-form ref="form">
						<v-text-field v-model="newProject.id" label="Project ID"
							:rules="[(v) => !!v || 'Project ID is required']" required></v-text-field>
						<v-text-field v-model="newProject.name" label="Project Name"
							:rules="[(v) => !!v || 'Project name is required']" required></v-text-field>
						<v-select v-model="newProject.clientIDs" :items="connections" label="Select Clients"
							item-text="name" item-value="clientID" chips multiple :rules="[
								(v) => v.length > 0 || 'At least one client must be selected',
							]" required></v-select>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-btn color="primary" text @click="dialogCreateProject = false">Cancel</v-btn>
					<v-btn color="success" text @click="createProject">Create</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogProjectDetails" max-width="600px" persistent>
			<v-card>
				<v-card-title>Project Details</v-card-title>
				<v-card-text>
					<v-form ref="detailsForm">
						<v-text-field v-model="selectedProject.id" label="Project ID" disabled></v-text-field>
						<v-text-field v-model="selectedProject.name" label="Project Name" disabled></v-text-field>
						<v-select v-model="selectedProject.clientIDs" :items="connections" label="Select Clients" item-text="name" item-value="clientID" chips multiple></v-select>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-btn color="primary" text @click="dialogProjectDetails = false">Close</v-btn>
					<v-btn color="success" text @click="saveProjectDetails">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import ConnectionAPI from "../../api/connections/connection"
import LoadingState from "../../consts/LoadingState"
import { mapState } from "vuex"
export default {
	name: "Connections",
	props: ["selected"],
	data() {
		return {
			headers: [
				{ text: "Client ID", value: "clientID", sortable: false, width: "20%" },
				{ text: "Name", value: "name", sortable: true, width: "60%" },
				{ text: "Remove", value: "remove", sortable: false, width: "0%" },
				{ text: "View", value: "view", sortable: false, width: "0%" }
			],
			headersProject: [
				{ text: "Project ID", value: "id", sortable: false, width: "20%" },
				{ text: "Project Name", value: "name", sortable: true, width: "30%" },
				{ text: "Clients Involved", value: "clientIDs", sortable: false, width: "20%" },
				{ text: "Delete", value: "delete", sortable: false, width: "0%" },
				{ text: "Details", value: "view", sortable: false, width: "0%" }
			],
			projects: [],
			connections: [],
			interval: null,
			type: null,
			clientID: null,
			name: null,
			date: null,
			formIsValid: false,
			types: [{ text: "", value: "" }],
			dialogDelete: false,
			dialogProjectDelete: false,
			itemToDelete: null,
			itemToDeleteProject: null,
			search: "",
			dialogCreateProject: false,
			dialogProjectDetails: false,
			newProject: {
				id: "",
				name: "",
				clientIDs: []
			},
			selectedProject: {
				id: "",
				name: "",
				clientIDs: []
			},
		}
	},
	mounted() {
		this.loadItems()
		this.loadProjects()
	},
	methods: {
		loadItems() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			ConnectionAPI.getConnections()
				.then(data => {
					this.connections = []
					for (let entry of data) {
						this.connections.push({
							clientID: entry.clientID,
							name: entry.name,
							IsGuest: entry.IsGuest,
							remove: null
						})
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		loadProjects() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			ConnectionAPI.getProjects()
				.then(data => {
					this.projects = data.map(project => ({
						id: project.ProjectID,
						name: project.ProjectName,
						clientIDs: typeof project.Involved === "string" ? project.Involved.split(",").map(id => parseInt(id, 10)) : project.Involved					}))
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				}) 
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		setSendingFalse: function () {
			this.isSending = false
		},
		showProjectDetails(item) {
			this.selectedProject = { ...item }
			this.dialogProjectDetails = true
		},
		removeRow() {
			this.dialogDelete = false
			let index = this.connections.indexOf(this.itemToDelete)
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			ConnectionAPI.deleteConnection(this.itemToDelete.clientID)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Connection was successfully removed from the list.",
						{ root: true }
					)
					this.connections.splice(index, 1)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		DeleteProject() {
			this.dialogProjectDelete = false
			let index = this.projects.indexOf(this.itemToDeleteProject)
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			ConnectionAPI.deleteProject(this.itemToDeleteProject.id,this.itemToDeleteProject.name)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Project was successfully deleted from the list.",
						{ root: true }
					)
					this.projects.splice(index, 1)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		showDeleteDialog(item) {
			this.itemToDelete = item
			this.dialogDelete = !this.dialogDelete
		},
		showDeleteProjectDialog(item){
			this.itemToDeleteProject = item
			this.dialogProjectDelete = !this.dialogProjectDelete
		},
		redirectTo(item) {
			this.$router.push({ name: "Single Client View", params: { id: item.clientID } })
		},
		createProject() {
			const form = this.$refs.form
			if (form.validate()) {
				// Add the new project to the projects array
				this.projects.push({ ...this.newProject })
				//post the data to the database
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_START_LOADING,
					null,
					{ root: true }
				)
				ConnectionAPI.createProjects(this.newProject).then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Project was successfully created.",
						{ root: true }
					)
					this.newProject = {
						id: "",
						name: "",
						clientIDs: []
					},
					this.dialogCreateProject = false
					form.reset()
				}).catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})

				// Reset the form and close the dialog

			}
		},
		saveProjectDetails() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			const index = this.projects.findIndex(project => project.id === this.selectedProject.id)
			if (index !== -1) {
				ConnectionAPI.updateProject(this.selectedProject.id, this.selectedProject.name, this.selectedProject.clientIDs).then(()=>{
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Project details were successfully updated.",
						{ root: true }
					)
					this.projects.splice(index, 1, { ...this.selectedProject })
				}).catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
			}
			this.dialogProjectDetails = false
		}
	},
	computed: {
		...mapState("loading", {
			loading: state => state.loading == LoadingState.LOADING
		})
	},
	watch: {
		selected() {
			this.loadItems()
		}
	}
}
</script>
